export default __webpack_public_path__ + "static/media/face_3_27.cbf2e00b.png";